import React from 'react'
import { graphql, Link } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Layout from '../../components/layout'

const Index = ({ data }) => {
  const sumallyNum = 500 // 研究内容紹介文の表示文字数上限
  
  const sumallyString = data.sumally.edges[0].node.frontmatter.descriptionEn
  let sumally = sumallyString.length > sumallyNum ? sumallyString.substr(0, sumallyNum) + '...' : sumallyString

  const ArrowLeft = (props) => {
    const { onClick } = props

    return (
      <div
        className="slick-myprev"
        onClick={onClick}
        onKeyDown={ () => 0 }
        role="button"
        aria-label="previous"
        tabIndex={0}
      />
    );
  }

  const ArrowRight = (props) => {
    const { onClick } = props

    return (
      <div
        className="slick-mynext"
        onClick={onClick}
        onKeyDown={ () => 0 }
        role="button"
        aria-label="next"
        tabIndex={0}
      />
    );
  }

  const slickSetting = {
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    prevArrow: <ArrowLeft />,
 　　nextArrow: <ArrowRight />,
    dots: false,
    // fade: true,
  }

  return (
    <Layout
      description={ sumallyString }
      lang="en"
    >
      <div className="container section">
        <div className="columns">
          <div className="col-6 col-tablet-6 col-mobile-12">
            <p className="text-size-3 text-weight-semibold text-centered heading">TANAKA Lab</p>
            <p className="text-size-7 text-color-light text-centered">{sumally}</p>
            <p className="text-size-5 text-weight-semibold text-centered heading"><Link className="linkButton" to="/en/research/">Learn more</Link></p>
          </div>
          <div className="col-6 col-tablet-6 col-mobile-12">
            <div className="slider-wrapper">
              <Slider className="slider-content" { ...slickSetting }>
                {
                  data.slick.edges.map( ({node}, idx) => {
                    return (
                      <div className="slick-wrapper" key={idx}>
                        <div className="slick-content">
                          <Img
                            fluid={node.childImageSharp.fluid}
                            className="slick-image"
                            objectFit="contain"
                          />
                        </div>
                      </div>
                    )
                  } )
                }
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Index

export const query = graphql`
query IndexEnQuery {
  sumally: allMarkdownRemark(
    filter: {
      frontmatter: {
        type: {eq: "researchSummary"}
      }
    }
    ) {
    edges {
      node {
        frontmatter {
          descriptionEn
        }
      }
    }
  }

  slick: allFile(
    filter: { sourceInstanceName: { eq: "slick" } },
    sort: { order: ASC, fields: [name] }
    ) {
    edges {
      node {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
}
`;